import { Navigate, Outlet, useLocation } from 'react-router'
import SplashScreen from '@/components/layout/SplashScreen'
import { useAuth } from './AuthProvider'

export default function RequireAuth() {
  const { status } = useAuth()
  const location = useLocation()

  if (status === 'loading') return <SplashScreen />

  if (status === 'anon') {
    // Survive the round trip through email: the deep link the user wanted is
    // restored after the code exchange in AuthCallback.
    sessionStorage.setItem('sa:redirect', location.pathname + location.search)
    return <Navigate to="/sign-in" replace />
  }

  return <Outlet />
}
